// extracted by mini-css-extract-plugin
module.exports = {"dialogBanner":"TermTranslationsUpload_dialog-banner__39M-D","formResultField":"TermTranslationsUpload_form-result-field__lb1W8"};